// extracted by mini-css-extract-plugin
export default {"wrapper":"underConstruction_wrapper__ye53s","borderPulse":"underConstruction_borderPulse__m+vkh","video":"underConstruction_video__qDws9"};